import { Component, OnInit, HostListener } from '@angular/core';
import { ViewportScroller} from '@angular/common';
import * as $ from "jquery";
import 'jquery';
import '../../../../assets/js/material-kit';
import '../../../../assets/js/jquery';
import '../../../../assets/js/nicepage';

import {NavigatorService} from "../../../services/navigatorService/navigator.service";
import {UserService} from "../../../services/api-handlers/userService/user.service";
import {BootstrapNotifyService} from "../../../services/bootstrap-notify/bootstrap-notify.service";
import {CacheService} from "../../../services/cacheService/cache.service";
import {SharedFormService} from "../../../services/shared-form.service";

@Component({
  selector: 'app-payment-page',
  templateUrl: './payment-page.component.html',
  styleUrls: ['./payment-page.component.css']
})
export class PaymentPageComponent implements OnInit {
  public credentials: any;
  Amount = 4500;
  Narration = 'Online Admission Fee';
  pageYoffset = 0;
  public loading = false;
  public year: number = new Date().getFullYear();
  loaders = {
    loading: false
  };

  @HostListener('window:scroll', ['$event']) onScroll(event){
    this.pageYoffset = window.pageYOffset;
  }
  constructor(private userService: UserService, private cacheService: CacheService,
              private bootstrapService: BootstrapNotifyService, private scroll: ViewportScroller, private navigationService: NavigatorService, private sharedFormService: SharedFormService) { }


  public scrollToContact() {

    if ($('.section-contact-us').length != 0) {
      $("html, body").animate({
        scrollTop: $('.section-contact-us').offset().top
      }, 1000);
    }
  };

  ngOnInit(): void {
    console.log('Preview Page Message', this.sharedFormService.admissionData);
    // this.credentials = this.sharedFormService.admissionData;
    this.credentials = JSON.parse(localStorage.getItem('LoginCredentials'));
  }


  scrollToTop(){
    this.scroll.scrollToPosition([0,0]);
  }


  ngOnDestroy(): void {
  localStorage.removeItem('LoginCredentials');
  }
}
